import { CampaignStatsOption } from '../../../utils/types';

export const CAMPAIGN_STATS_OPTIONS: CampaignStatsOption[] = [
  // Campaign State Options
  { id: 'active', name: 'Active', category: 'state' },
  { id: 'inactive', name: 'Inactive', category: 'state' },
  { id: 'needs-approval', name: 'Needs Approval', category: 'state' },
  { id: 'no-whitelist', name: 'No Whitelist', category: 'state' },
  { id: 'payout-issues', name: 'Payout Issues', category: 'state' },
  { id: 'removed-from-feed', name: 'Removed from Feed', category: 'state' },
  
  // Region Targeting Options
  { id: 'region-targeted', name: 'Region Targeted', category: 'region' },
  { id: 'non-region-targeted', name: 'Non-Region Targeted', category: 'region' }
];

export default CAMPAIGN_STATS_OPTIONS;